module.exports = __webpack_public_path__ + "static/media/bm.766b6aa4.svg";